
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  inject,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { DimmerComponent } from '../dimmer/dimmer.component';

@Component({
    selector: 'sirius-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, DimmerComponent]
})
export class ModalComponent implements OnInit, AfterViewInit {
    @Input() fullscreen = true;
    @Output() modalClose = new EventEmitter<void>();
    @ViewChild('container', { read: ElementRef }) containerRef?: ElementRef;

    private _initialized = false;
    private _document = inject(DOCUMENT);
    private _renderer = inject(Renderer2);

    @HostBinding('class.sir-fullscreen')
    get isFullscreen(): boolean {
        return this.fullscreen;
    }

    @HostListener('keydown.escape')
    handleKeyDown(): void {
        this.close();
    }

    @HostListener('document:click', ['$event'])
    clickOutside(event: FocusEvent) {
        if (!this._initialized) {
            return;
        }

        const target = event.target as HTMLElement;
        if (!target) {
            return;
        }
        if (!this.containerRef?.nativeElement.contains(target)) {
            this.close();
        }
    }

    ngOnInit(): void {
        this._renderer.setStyle(this._document.body, 'overflow-y', 'hidden');
    }

    ngAfterViewInit(): void {
        this.containerRef?.nativeElement.focus();
        setTimeout(() => {
            this._initialized = true;
        }, 0);
    }

    close(): void {
        this.modalClose.emit();
        this._renderer.setStyle(this._document.body, 'overflow-y', 'auto');
    }
}
